import React from 'react';
// Importando as imagens do diretório local
import logo from './figures/Logotipo.png'; // Caminho atualizado
import logomarca from './figures/INNEXLogo.jpg'
import backgroundImage from './figures/mihajlo-sivc-X-No-C4wnUo-unsplash.jpg'; // Imagem de fundo atualizada
// Importando os SVGs como componentes React
import { ReactComponent as InnexImage } from './figures/INNEX.svg'; 
import { ReactComponent as IconSegurancaDados } from './figures/iconSegurancaDados.svg';
import { ReactComponent as IconSegurancaAfetada } from './figures/iconSegurancaAfetada.svg';
// Importando os logos das parcerias
import SenaiCimatecLogo from './figures/SenaiCimatecLogo.png';
import QuIINLogo from './figures/QuIINLogo.png';
import linkedinLogo from './figures/linkedinLogo.png';


// O import para './App.css' não é mais necessário se você estiver usando apenas Tailwind.
// Certifique-se de que o Tailwind CSS está configurado no seu projeto.

// Componente para o ícone do logo com classes do Tailwind
const AppLogo = () => (
  <div>
    <img 
      src={logo}
      alt="Logo da Empresa" 
      className="h-10 sm:h-12 w-auto" 
    />
  </div>
);

// Componente para as opções do menu com classes do Tailwind
/*
const MenuOptions = () => {
  // Classes base para os links do menu para evitar repetição
  const linkClasses = "whitespace-nowrap text-sm sm:text-base md:text-lg lg:text-xl font-sans font-bold text-[#F9F9F9] hover:opacity-80 py-2 px-2 md:px-3 rounded-md transition-opacity duration-300";

  return (
    <nav>
      <ul className="flex items-center space-x-2 sm:space-x-4 lg:space-x-8">
        <li><a href="#home" className={linkClasses}>Início</a></li>
        <li><a href="#tecnologias" className={linkClasses}>Tecnologias</a></li>
        <li><a href="#empresa" className={linkClasses}>Empresa</a></li>
        <li><a href="#trabalheconosco" className={linkClasses}>Trabalhe Conosco</a></li>
        <li><a href="#contatos" className={linkClasses}>Contatos</a></li>
      </ul>
    </nav>
  );
};*/

// Componente para os itens de feature na seção "Por que Quântica"
const FeatureItem = ({ title, children }) => (
    <li className="mt-6 text-left">
        <span className="font-bold text-[#F9F9F9] text-lg"> • {title}:</span>
        <span className="text-gray-300 leading-relaxed"> {children}</span>
    </li>
);


function App() {
  return (
    // Novo contêiner geral para permitir as seções abaixo
    <div className="overflow-x-hidden scroll-smooth bg-[#000000]">
      {/* Contêiner principal com a imagem de fundo e layout de coluna flex */}
      <div 
        className="relative min-h-screen bg-cover bg-center font-sans flex flex-col"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        {/* Header com fundo transparente e padding responsivo */}
        <header className="flex items-center justify-between px-4 sm:px-6 md:px-10 py-8">
          <AppLogo />
          {/*<MenuOptions />*/}
        </header>

        {/* Conteúdo principal que agora organiza o texto e os botões verticalmente */}
        <main className="flex-grow px-6 sm:px-10 md:px-20 lg:px-32 flex flex-col">
          
          {/* Div invisível que cresce para empurrar o conteúdo para baixo */}
          <div className="flex-grow" />
          
          {/* Seção do texto */}
          <div className="max-w-2xl">
              <h2 className="text-3xl sm:text-4xl font-bold text-[#F9F9F9]">Discover</h2>
              {/* Usando o SVG importado como um componente */}
              <InnexImage className="h-16 sm:h-20 w-auto my-2" />
              <p className="mt-4 text-base sm:text-lg text-gray-200 leading-relaxed">
                  Pioneering next-generation hardware and software innovation for quantum-secure communication delivering trusted solutions for critical and high-security sectors.
              </p>
          </div>
          
          {/* Contêiner dos botões com espaçamento vertical */}
          <div className="py-10">
              <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-10">
                <a href="#quem-somos" className="bg-[#5A199B] hover:bg-[#9D4EDD] text-[#F9F9F9] font-bold py-3 px-8 rounded-full transition-colors duration-300 w-full sm:w-auto text-center">
                    LEARN MORE
                </a>
                <a href="mailto:innex@innex.co" className="bg-[#5A199B] hover:bg-[#9D4EDD] text-[#F9F9F9] font-bold py-3 px-8 rounded-full transition-colors duration-300 w-full sm:w-auto text-center">
                    CONTACT US
                </a>
              </div>
          </div>
        </main>

        {/* Retângulo de degradê na parte inferior da tela */}
        <div className="absolute bottom-0 left-0 w-full h-10 bg-gradient-to-b from-transparent to-black" />
      </div>

      {/* Seção "Quem Somos" com o ID para a âncora */}
      <div id="quem-somos" className="bg-black p-8 md:p-20">
        <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row items-center gap-10">
          {/* Coluna da Esquerda: Logo */}
          <div className="flex-shrink-0">
            <img src={logomarca} alt="Logo da INNEX" className="h-64 md:h-80 w-auto" />
          </div>

          {/* Coluna da Direita: Texto */}
          <div className="text-left">
            <div className="inline-block">
              <h2 className="mr-5 text-xl md:text-2xl font-bold text-[#F9F9F9] tracking-wider">
                MISSION, VISION, AND VALUES
              </h2>
              <div className="mt-1 h-[2px] w-full bg-gradient-to-r from-[#F9F9F9] via-[#F9F9F9] via-80% to-transparent" />
            </div>
            <p className="mt-4 text-gray-300 leading-relaxed">
              "At INNEX, we directly confront the greatest challenge of the digital age: protecting information in the imminent post-quantum era. Our mission is to develop secure data communication solutions with the highest technical rigor, integrating cutting-edge hardware and software to ensure the digital sovereignty of our clients and partners. Our vision is to be the global benchmark in this sector, driving innovation in optical connectivity and advanced cryptography from Brazil. We do not walk this path alone. We believe in the power of scientific collaboration, embodied in our strategic alliance with QUINN - Quantum Industrial Innovation - and partnerships with centers of excellence such as SENAI CIMATEC. Every step we take is guided by non-negotiable values: innovation with purpose, absolute security and reliability, and a relentless pursuit of technical excellence. INNEX is your strategic partner on the journey to a resilient and secure digital future. Join us."
            </p>
          </div>
        </div>
      </div>

      {/* Seção de degradê de transição */}
      <div className="w-full h-20 bg-gradient-to-b from-black to-[#11002C]" />

      {/* Seção "Missão, Visão e Valores" */}
      <div className="bg-[#11002C] p-8 md:p-20">
        <div className="max-w-screen-xl mx-auto">
            <div className="text-center">
              <div className="inline-block">
                <h2 className="px-5 text-xl md:text-2xl font-bold text-[#F9F9F9] tracking-wider">
                  ABOUT US
                </h2>
                <div className="mt-1 h-[2px] w-full bg-[linear-gradient(to_right,transparent_0%,#F9F9F9_20%,#F9F9F9_80%,transparent_100%)]" />
              </div>
            </div>
            <p className="mt-4 text-gray-300 leading-relaxed">
              INNEX is a Brazilian deeptech startup dedicated to data security and high-performance connectivity. We operate in the development of solutions that combine Post-Quantum Cryptography (PQC), Free Space Optical (FSO) communication, and integration with nanosatellites. Born within the QuINN – Quantum Industrial Innovation ecosystem and in strategic partnership with SENAI CIMATEC, we have built a proprietary hardware and software platform designed for critical sectors such as finance, healthcare, and government. We believe that digital sovereignty begins with information security — and INNEX is ready for that future.
            </p>
        </div>
      </div>

      {/* Seção de degradê de transição */}
      <div className="w-full h-20 bg-gradient-to-b from-[#11002C] to-[#5A199B]" />

      {/* Seção "Por que Quântica Agora" */}
      <div className="bg-[#5A199B] p-8 md:p-20">
        <div className="max-w-screen-xl mx-auto">
            <div className="text-center">
              <div className="inline-block">
                <h2 className="px-5 text-xl md:text-2xl font-bold text-[#F9F9F9] tracking-wider">
                  WHY QUANTUM AND WHY NOW
                </h2>
                <div className="mt-1 h-[2px] w-full bg-[linear-gradient(to_right,transparent_0%,#F9F9F9_20%,#F9F9F9_80%,transparent_100%)]" />
              </div>
            </div>
            
            <div className='mt-10 grid md:grid-cols-2 gap-16 items-center'>
                {/* Item 1 (Texto 1): Ordem 1 em mobile e desktop */}
                <ul className="list-none">
                    <FeatureItem title="The Evolution of Quantum Computing">
                        Quantum computing is no longer a distant promise,  it is knocking at our door. Leading technology companies now provide cloud access to their quantum prototypes, accelerating the race for practical applications and signaling that the impact of this new computational paradigm is closer than ever.
                    </FeatureItem>
                    <FeatureItem title="Security Breaches">
                        The advent of a fully functional quantum computer will mark the greatest security disruption in digital history, rendering much of today’s cryptography obsolete. Quantum algorithms will be capable of factoring asymmetric keys in record time, exposing financial, governmental, and personal data previously considered secure.
                    </FeatureItem>
                </ul>

                {/* Item 2 (Imagem 1): Ordem 2 em mobile e desktop */}
                <div className="flex justify-center">
                  <IconSegurancaAfetada className="h-64 md:h-80 w-auto text-[#F9F9F9]" alt="Ícone de Segurança Afetada" />
                </div>

                {/* Item 3 (Texto 2): Ordem 3 em mobile, mas ordem 4 (última) em desktop */}
                <ul className="list-none md:order-4">
                    <FeatureItem title="Data Protection">
                        To ensure data protection in the quantum era  the cybersecurity industry is developing resilient defenses. The transition to Post-Quantum Cryptography (PQC), featuring mathematically resistant algorithms, and the implementation of Quantum Key Distribution (QKD) are the pillars ensuring long-term data confidentiality and integrity.
                    </FeatureItem>
                    <FeatureItem title="Wireless Data Transmission">
                        Quantum Key Distribution security extends beyond traditional fiber-optic networks. Through Free-Space Optical (FSO) technology, wireless transmission of quantum keys is already a reality, enabling the creation of ultra-secure enclaves between satellites, aircraft, and ground stations ensuring communication protected by the very laws of physics.
                    </FeatureItem>
                </ul>

                {/* Item 4 (Imagem 2): Ordem 4 em mobile, mas ordem 3 em desktop */}
                <div className="flex justify-center md:order-3">
                  <IconSegurancaDados className="h-64 md:h-80 w-auto text-[#F9F9F9]" alt="Ícone de Segurança de Dados" />
                </div>
            </div>
        </div>
      </div>

      {/* Seção de degradê de transição */}
      <div className="w-full h-20 bg-gradient-to-b from-[#5A199B] to-[#11002C]" />

      {/* Seção "Parcerias" */}
      <div className="bg-[#11002C] p-8 md:p-20">
        <div className="max-w-screen-xl mx-auto">
            <div className="text-center">
              <div className="inline-block">
                <h2 className="px-5 text-xl md:text-2xl font-bold text-[#F9F9F9] tracking-wider">
                  PARTNERSHIPS
                </h2>
                <div className="mt-1 h-[2px] w-full bg-[linear-gradient(to_right,transparent_0%,#F9F9F9_20%,#F9F9F9_80%,transparent_100%)]" />
              </div>
            </div>
            
            <div className="mt-16 flex justify-center items-center gap-10 md:gap-20 flex-wrap">
                <div className="p-4 rounded-lg bg-[#F9F9F9]">
                  <img src={SenaiCimatecLogo} alt="Logo Senai Cimatec" className="h-16 sm:h-20 w-auto" />
                </div>
                <div className="p-4 rounded-lg bg-[#F9F9F9]">
                  <img src={QuIINLogo} alt="Logo QuIIN" className="h-16 sm:h-20 w-auto" />
                </div>
            </div>
        </div>
      </div>
      
      {/* Seção de degradê de transição */}
      <div className="w-full h-20 bg-gradient-to-b from-[#11002C] to-black" />

      {/* Rodapé Final */}
      <footer className="bg-black text-[#F9F9F9] p-8 md:p-10">
        <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row justify-between items-center text-center md:text-left gap-10">
          {/* Coluna da Esquerda: Contato */}
          <div className="w-full md:w-auto">
            <h3 className="font-bold tracking-wider mb-2">REACH US:</h3>
            <p className="text-[#F9F9F9]">Get in touch with our team: </p>
            <a href="mailto:thiago@innex.co" className="text-[#9D4EDD] hover:underline">thiago@innex.co</a>
          </div>
          {/* Coluna da Direita: Siga-nos */}
          <div className="w-full md:w-auto">
            <h3 className="font-bold tracking-wider mb-2">CONNECT WITH US:</h3>
            <div className="flex justify-center md:justify-start">
              <a href="https://www.linkedin.com/company/107541020/admin/dashboard" className="hover:opacity-80 transition-opacity">
                <img src={linkedinLogo} alt="LinkedIn" className="h-14 w-14" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
